import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CampaignsManagerAPI from '../../api/campaignsManager';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { CAMPAIGN_MANAGERS_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  conversations:[],
  campaign: {
    title: null,
    inboxID: null,
    flowID: null,
    audienceSource: 'excel', // 'excel' | 'segment'
    segmentId: null,
    fileID: null,
    fileName: "",
    templateID: null,
    templateName: "",
    templateLanguage:"",
    templateFormat:"",
    templateVars: [],
    templateHeaderVars: [],
    templateButtonsVars: [],
    templateMediaImage: null,
    templateMediaVideo: null,
    templateMediaDocument:null,
    paramSourceTypes: {
      body: {},
      header: {},
      media: {},
      buttons: {},
    },
    sendNow: false,
    sendLater: false,
    deliveryType: null,
    startScheduleTime: null,
    endScheduleTime: null
  },

  campaignDetailPanel :{
    campaign_inbox_name:null,
    campaign_flow_name:null,
    campaign_total:null,
    campaign_created_by:null,
    campaign_schedule_start_at:null,
    template_text:null,
    statuses:{
       sent:{
          count:0,
          percentage:0
       },
       failed:{
          count:0,
          percentage:0
       },
       delivered:{
          count:0,
          percentage:0
       },
       read:{
          count:0,
          percentage:0
       },
       answered:{
          count:0,
          percentage:0
       }
    }
 },

  templateSampleData: [],
  segmentTemplateSampleData: {},
  inboxList: [],
  templateList: [],
  selectedTemplate: null,
  flowList: [],
  totalCount: 0,
  totalConversationsCount:0,
  originalFile: null,
  fileBlob: null,
  fileError: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isFetchingFlows: false,
    isFetchingInBoxes: false,
    isFetchingTemplates: false,
    isUploadingFile: false,
    isErrorUpload: null,
    isFetchingDetailPanel: false,
    isFetchingDetailConversations: false,
    isSendingTest :false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCampaigns: _state => {
    return _state.records
  },
  getCampaign: _state => {
    return _state.campaign
  },
  getAllCampaigns: _state => {
    return _state.records;
  },
  getCampaignDetailPanel: _state => {
    return _state.campaignDetailPanel;
  },
  getConversations: _state => {
    return _state.conversations;
  },

  getTotalCount($state) {
    return $state.totalCount;
  },
  getTotalConversationsCount($state) {
    return $state.totalConversationsCount;
  },
  getInboxList($state) {
    return $state.inboxList;
  },
  getFlowList($state) {
    return $state.flowList;
  },
  getTemplateList($state) {
    return $state.templateList;
  },
  

  getSelectedTemplate($state) {
    return $state.selectedTemplate;
  },
  getTemplateSampleData($state) {
    return $state.templateSampleData
  },
  getSegmentTemplateSampleData($state) {
    return $state.segmentTemplateSampleData;
  },
  getFileBlobData($state) {
    return $state.fileBlob
  },
  getFileError($state) {
    return $state.fileError
  }

};

export const actions = {
  get: async ({ commit }, params) => {

    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetching: true });

    try {

      const response = await CampaignsManagerAPI.get(params);
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetching: false });
      commit(types.SET_CAMPAIGN_MANAGERS, response.data);
      commit("setTotalCount", response.headers["count"]);

    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetching: false });
    }
  },

  getCampaignDetailPanel: async ({ commit }, params) => {

    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailPanel: true });

    try {

      const response = await CampaignsManagerAPI.getCampaignDetailPanel(params);
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailPanel: false });
      commit("setCampaignDetailPanel", response.data);


    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailPanel: false });
    }
  },

  getCampaignConversations: async ({ commit }, params) => {

    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailConversations: true });

    try {

      console.log(params)

      const response = await CampaignsManagerAPI.getCampaignDetailConversations(params.id,params.queryParams);
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailConversations: false });
      commit("setCampaignDetailConversations", response.data);
      commit("setTotalConversationsCount", response.headers["count"]);

    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailPanel: false });
    }
  },
  exportConversations: async ({ commit }, params) => {

   //commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailConversations: true });

    try {

  

      const response = await CampaignsManagerAPI.exportCampaignDetailConversations(params.id,params.queryParams);
      //commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailConversations: false });
      //commit("setCampaignDetailConversations", response.data);
     /// commit("setTotalConversationsCount", response.headers["count"]);

    } catch (error) {
      console.log(error);
    } 
    /*
    finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingDetailPanel: false });
    }*/
  },
  create: async function createCampaign({ commit }, campaignObj) {
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignsManagerAPI.create(campaignObj);
      //commit(types.ADD_CAMPAIGN_MANAGER, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isCreating: false });
    }
  },
  sendTestMessage: async ({ commit }, campaignObj) =>{
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isSendingTest: true });
    try {
      const response = await CampaignsManagerAPI.sendTestMessage(campaignObj);
      //commit(types.ADD_CAMPAIGN_MANAGER, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isSendingTest: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUpdating: true });
    try {
      const response = await CampaignsManagerAPI.update(id, updateObj);
      AnalyticsHelper.track(CAMPAIGN_MANAGERS_EVENTS.UPDATE_CAMPAIGN_MANAGER);
      commit(types.EDIT_CAMPAIGN_MANAGER, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isDeleting: true });
    try {
      await CampaignsManagerAPI.delete(id);
      AnalyticsHelper.track(CAMPAIGN_MANAGERS_EVENTS.DELETE_CAMPAIGN_MANAGER);
      commit(types.DELETE_CAMPAIGN_MANAGER, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isDeleting: false });
    }
  },
  getFlows: async ({ commit }, params) => {

    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingFlows: true });

    try {

      const response = await CampaignsManagerAPI.getFlowList();
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingFlows: false });
      commit("setFlowList", response.data);


    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingFlows: false });
    }
  },

  getInboxes: async ({ commit }, params) => {

    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingInBoxes: true });

    try {

      const response = await CampaignsManagerAPI.getInboxList();
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingInBoxes: false });
      commit("setInboxList", response.data);


    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingInBoxes: false });
    }
  },
  getTemplates: async ({ commit, state }, params) => {
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingTemplates: true });
    try {
      const response = await CampaignsManagerAPI.getTemplateList(state.campaign.inboxID);
      commit('setTemplateList', response.data);
    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetchingTemplates: false });
    }
  },
  uploadFile: async function uploadFileCampaign({ commit }, file) {


    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingFile: true, isErrorUpload:null });
    commit('setFileID', null);
    commit('setFileName', "");
    commit('setOriginalFile', file);

    try {

      let formData = new FormData();
      formData.append('file', file);

      const response = await CampaignsManagerAPI.uploadFile(formData);

      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingFile: false, isErrorUpload:false });
      commit("setFileTemplateData",{ fileName: file.name, data: response.data});
      
      
    } catch (error) {
      
      let errorBody = null;

      if (error.response) {
        // Captura el body del error 500 u otro error de respuesta
        errorBody = error.response.data;
        console.error('Error Body:', errorBody);
      } else if (error.request) {
        // El request fue hecho pero no hubo respuesta
        console.error('No response received:', error.request);
      } else {
        // Algo ocurrió al preparar la petición
        console.error('Error setting up request:', error.message);
      }
    
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingFile: false, isErrorUpload: true});
      
      // Si quieres guardar el body del error para uso posterior
      commit("setFileTemplateError", { errorBody });
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingFile: false });
    }
  },
  getFileBlob: async ({ commit }, params) => {
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetching: true });
    try {
      const response = await CampaignsManagerAPI.getFileBlob(params);

      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetching: false });
      commit("setFileBlob", response.data);
    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isFetching: false });
    }
  },
  updateTitle: ({ commit }, title) => {
    commit("setTitle", title);
  },

  updateInboxID: ({ commit }, inboxID) => {
    commit("setInboxID", inboxID);
  },
  updateFlowID: ({ commit }, flowID) => {
    commit("setFlowID", flowID);
  },
  updateFileID: ({ commit }, fileID) => {
    commit("setFileID", fileID);
  },
  updateFileName: ({ commit }, fileName) => {
    commit("setFileName", fileName);
  },
  updateAudienceSource: ({ commit }, audienceSource) => {
    commit("setAudienceSource", audienceSource);
  },
  updateSegmentId: ({ commit }, segmentId) => {
    commit("setSegmentId", segmentId);
  },
  updateTemplateID: ({ commit }, templateID) => {
    commit("setTemplateID", templateID);
  },
  updateTemplateName: ({ commit }, templateName) => {
    commit("setTemplateName", templateName);
  },
  updateTemplateLanguage: ({ commit }, templateLanguage) => {
    commit("setTemplateLanguage", templateLanguage);
  },
  updateTemplateFormat: ({ commit }, templateFormat) => {
    commit("setTemplateFormat", templateFormat);
  },
  updateTemplateVars: ({ commit }, templateID) => {
    commit("setTemplateVars", templateID);
  },
  updateSendNow: ({ commit }, sendNow) => {
    commit("setSendNow", sendNow);
  },
  updateSendLater: ({ commit }, sendLater) => {
    commit("setSendLater", sendLater);
  },
  updateDeliveryType: ({ commit }, deliveryType) => {
    commit("setDeliveryType", deliveryType);
  },
  updateStartScheduleTime: ({ commit }, startScheduleTime) => {
    commit("setStartScheduleTime", startScheduleTime);
  },
  updateEndScheduleTime: ({ commit }, endScheduleTime) => {
    commit("setEndScheduleTime", endScheduleTime);
  },
  updateParamSourceType: ({ commit }, payload) => {
    commit("setParamSourceType", payload);
  },
  uploadMediaFile: async function uploadMediaFileCampaign({ commit }, file) {
    commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingMedia: true });
    try {
      let formData = new FormData();
      formData.append('attachment', file);
      const accountId = window.location.pathname.split('/')[3];
      const response = await axios.post(
        `/api/v1/accounts/${accountId}/upload`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingMedia: false });
      return response.data.file_url;
    } catch (error) {
      commit(types.SET_CAMPAIGN_MANAGER_UI_FLAG, { isUploadingMedia: false });
      throw error;
    }
  },
  clearState :({ commit }) => {
    commit("setClearState");
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_MANAGER_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_CAMPAIGN_MANAGER]: MutationHelpers.create,
  [types.SET_CAMPAIGN_MANAGERS]: MutationHelpers.set,
  [types.EDIT_CAMPAIGN_MANAGER]: MutationHelpers.update,
  [types.DELETE_CAMPAIGN_MANAGER]: MutationHelpers.destroy,
  setCampaignDetailPanel($state, data) {
    if (data) {
      $state.campaignDetailPanel = data
    } else {
      $state.campaignDetailPanel = []
    }
  },
  setCampaignDetailConversations($state, data) {
    if (data) {
      $state.conversations = data
    } else {
      $state.conversations = []
    }
  },
  setTotalCount($state, count) {
    if (count) {
      $state.totalCount = parseInt(count)
    } else {
      $state.totalCount = 0
    }
  },
  setTotalConversationsCount($state, count) {
    if (count) {
      $state.totalConversationsCount = parseInt(count)
    } else {
      $state.totalConversationsCount = 0
    }
  },
  setFlowList($state, flowList) {
    $state.flowList = flowList
  },
  setInboxList($state, inboxList) {
    $state.inboxList = inboxList
  },

  setTemplateList($state, templateList) {
    $state.templateList = templateList
  },
  setTitle($state, title) {
    $state.campaign.title = title
  },
  setInboxID($state, inboxID) {
    $state.campaign.inboxID = inboxID
  },
  setFlowID($state, flowID) {
    $state.campaign.flowID = flowID
  },
  setFileID($state, fileID) {
    $state.campaign.fileID = fileID
  },
  setFileName($state, fileName) {
    $state.campaign.fileName = fileName
  },
  setAudienceSource($state, audienceSource) {
    $state.campaign.audienceSource = audienceSource
  },
  setSegmentId($state, segmentId) {
    $state.campaign.segmentId = segmentId
  },
  setTemplateID($state, templateID) {
    $state.campaign.templateID = templateID
  },
  setTemplateName($state, templateName) {
    $state.campaign.templateName = templateName
  },
  setTemplateLanguage($state, templateLanguage) {
    $state.campaign.templateLanguage = templateLanguage
  },

  setTemplateFormat($state, templateFormat) {
    $state.campaign.templateFormat = templateFormat
  },
  setTemplateVars($state, templateID) {

    $state.selectedTemplate = $state.templateList.filter((item) => {
      return item.id == templateID
    })[0]

    console.log("selectedTemplate", $state.selectedTemplate)

    let optionsHeader = []
    
    const templateHeaderText = $state.selectedTemplate.components.filter(component => component.format && component.format === "TEXT" && component.type === "HEADER");
    const templateHeaderImage = $state.selectedTemplate.components.filter(component => component.format && component.format === "IMAGE" && component.type === "HEADER");
    const templateHeaderVideo = $state.selectedTemplate.components.filter(component => component.format && component.format === "VIDEO" && component.type === "HEADER");
    const templateHeaderDocument = $state.selectedTemplate.components.filter(component => component.format && component.format === "DOCUMENT" && component.type === "HEADER");


    let optionsBody = []

    if ($state.selectedTemplate.parameter_format === "NAMED") {
      // Buscar el componente BODY para obtener los parámetros nombrados
      const bodyComponent = $state.selectedTemplate.components.find(comp => comp.type === "BODY");
      if (bodyComponent && bodyComponent.text) {
        // Extraer nombres de parámetros del texto usando regex
        const paramRegex = /\{\{([^}]+)\}\}/g;
        const matches = bodyComponent.text.match(paramRegex);
        if (matches) {
          // Extraer nombres únicos de parámetros
          const paramNames = [...new Set(matches.map(match => match.slice(2, -2)))];
          paramNames.forEach(paramName => {
            let item = {}
            item[paramName] = "";
            optionsBody.push(item);
          });
        }
      }




      const headerComponent = $state.selectedTemplate.components.find(comp => comp.type === "HEADER");
      if (headerComponent && headerComponent.text) {
        // Extraer nombres de parámetros del texto usando regex
        const paramRegex = /\{\{([^}]+)\}\}/g;
        const matches = headerComponent.text.match(paramRegex);
        if (matches) {
          // Extraer nombres únicos de parámetros
          const paramNames = [...new Set(matches.map(match => match.slice(2, -2)))];
          paramNames.forEach(paramName => {
            let item = {}
            item[paramName] = "";
            optionsHeader.push(item);
          });


        }
      }


    } else {
      // Formato numérico (comportamiento original)
      for (var i = 1; i <= $state.selectedTemplate.body_count; i++) {
        let item = {}
        item[i] = "";
        optionsBody.push(item);
      }

   
        for (var i = 1; i <= $state.selectedTemplate.header_count; i++) {
            let item = {}
            item[i] = "";
            optionsHeader.push(
              item
            )
          }
        
    }



    $state.campaign.templateMediaImage=null
    if( templateHeaderImage.length){
      $state.campaign.templateMediaImage ={ "field" : "" }
    }

    $state.campaign.templateMediaVideo=null
    if( templateHeaderVideo.length){
      $state.campaign.templateMediaVideo ={ "field" : "" }
    }
    $state.campaign.templateMediaDocument=null
    if( templateHeaderDocument.length){
      $state.campaign.templateMediaDocument ={ "field" : "" }
    }

    $state.campaign.templateButtonsVars= [];
    const templateBottons = $state.selectedTemplate.components.filter(component => component.type && component.type =="BUTTONS" );
 
    if(templateBottons && templateBottons.length){
      
    
    //const templateUrlButtons = templateBottons[0].buttons.filter(button => button.type && button.type === "URL"  );


    

    let optionsButtons = []

    for (var i = 0; i <= templateBottons[0].buttons.length-1; i++) {

      if(templateBottons[0].buttons[i].type === "URL"  && templateBottons[0].buttons[i].url.includes('{{1}}')){
        let item = {}
        item[i] = "";
        optionsButtons.push(item)
      }
    }

    $state.campaign.templateButtonsVars = optionsButtons

  }
    $state.campaign.paramSourceTypes = { body: {}, header: {}, media: {}, buttons: {} };
    $state.campaign.templateName = $state.selectedTemplate.name;
    $state.campaign.templateLanguage =  $state.selectedTemplate.language;
    $state.campaign.templateFormat =$state.selectedTemplate.parameter_format;
    $state.campaign.templateVars = optionsBody;
    $state.campaign.templateHeaderVars = optionsHeader
   



  },
  setSendNow($state, sendNow) {
    $state.campaign.sendNow = sendNow
    if(sendNow){
      $state.campaign.deliveryType= "sendNow"
    }
  },
  setSendLater($state, sendLater) {
    $state.campaign.sendLater = sendLater
    if(sendLater){
      $state.campaign.deliveryType= "sendLater"
    }
  },
  
  setDeliveryType($state, deliveryType) {
    $state.campaign.deliveryType = deliveryType
  },
  setStartScheduleTime($state, startScheduleTime) {
    $state.campaign.startScheduleTime = startScheduleTime
  },
  setEndScheduleTime($state, endScheduleTime) {
    $state.campaign.endScheduleTime = endScheduleTime
  },

  setOriginalFile($state, file) {
    $state.originalFile = file;
  },
  setFileTemplateData($state, params) {
    $state.campaign.fileName = params.fileName  
    $state.campaign.fileID = params.data.file_id,
      $state.templateSampleData = params.data.sample_data
  },
  setSegmentTemplateSampleData($state, sampleData) {
    $state.segmentTemplateSampleData = sampleData || {};
  },


  setFileBlob($state, data) {
    $state.fileBlob = data
  },
  setClearState($state){

      $state.campaign.title= null
      $state.campaign.inboxID=null
      $state.campaign.flowID= null
      $state.campaign.audienceSource = 'excel'
      $state.campaign.segmentId = null
      $state.campaign.fileID= null
      $state.campaign.fileName= ""
      $state.campaign.templateID= null
      $state.campaign.templateName= ""
      $state.campaign.templateLanguage=""
      $state.campaign.templateFormat=""
      $state.campaign.templateVars= []
      $state.campaign.paramSourceTypes= { body: {}, header: {}, media: {}, buttons: {} }
      $state.originalFile = null
      $state.campaign.sendNow= false
      $state.campaign.sendLater= false
      $state.campaign.startScheduleTime= null
      $state.campaign.endScheduleTime= null
      $state.segmentTemplateSampleData = {}
    


  },
  setParamSourceType($state, { category, key, sourceType }) {
    // category: 'body'|'header'|'media'|'buttons'
    // key: the param key (e.g. 'name', '1', 'Image')
    // sourceType: 'column'|'static'|'file'
    $state.campaign.paramSourceTypes = {
      ...$state.campaign.paramSourceTypes,
      [category]: {
        ...$state.campaign.paramSourceTypes[category],
        [key]: sourceType,
      },
    };
  },
  setFileTemplateError($state, data) {
$state.fileError = data.errorBody.detail
  }





};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};